import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { ContentProvider } from './lib/content';
import { ThemeProvider } from './lib/storage';
import { HomePage } from './pages/HomePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { QuizPage } from './pages/QuizPage';
import { SurahPage } from './pages/SurahPage';

export function App({ initialSurah = null, initialQuiz = null }) {
  return (
    <ContentProvider initialSurah={initialSurah} initialQuiz={initialQuiz}>
      <ThemeProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/soera/:surahSlug" element={<SurahPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </ThemeProvider>
    </ContentProvider>
  );
}
